<template>
    <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="data-table__head">
            <div class="data-table-sort">
              <p>Pokaż</p>
              <select v-model="perPage" @change="setPerPage()">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <p>pozycji</p>
            </div>
            <div class="button-group" v-if="$parent.grantPermission(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])">
              <span class="button-module-table" @click="generateReport()">
                <svg viewBox="0 0 21 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-1504.000000, -212.000000)" fill="#E3000B" fill-rule="nonzero">
                            <g transform="translate(1456.000000, 212.000000)">
                                <g transform="translate(48.000000, 0.000000)">
                                    <polygon points="13.5 0 13.5 6.75 20.25 6.75"></polygon>
                                    <path d="M13.5,8.4375 C12.5701875,8.4375 11.8125,7.6798125 11.8125,6.75 L11.8125,0 L1.6875,0 C0.7576875,0 0,0.7576875 0,1.6875 L0,25.3125 C0,26.244 0.7576875,27 1.6875,27 L18.5625,27 C19.494,27 20.25,26.244 20.25,25.3125 L20.25,8.4375 L13.5,8.4375 Z M6.75,23.625 L3.375,23.625 L3.375,18.5625 L6.75,18.5625 L6.75,23.625 Z M11.8125,23.625 L8.4375,23.625 L8.4375,15.1875 L11.8125,15.1875 L11.8125,23.625 Z M16.875,23.625 L13.5,23.625 L13.5,11.8125 L16.875,11.8125 L16.875,23.625 Z" id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <p>Generuj raport</p>
              </span>
              <span class="button-module-table" @click="copy_popup = true">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-61 0 512 512"><g><path d="m180 210v-120h-180v422h300v-302zm30-111.300781v81.300781h81.300781zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/><path d="m381.300781 90h-81.300781v-81.300781zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/><path d="m90 0h180v116.398438l-56.398438-56.398438h-123.601562zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/><path d="m390 120v302h-60v-245.601562l-56.398438-56.398438zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/></g> </svg>
                <p>Kopiuj</p>
              </span>
              <span class="button-module-table" @click="deleteProduct()" v-if="$parent.grantPermission(['ROLE_EDITOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 443 443" style="enable-background:new 0 0 443 443;" xml:space="preserve"><g><g>
                  <path d="M321.785,38h-83.384V0H125.169v38H41.785v60h280V38z M155.169,30h53.232v8h-53.232V30z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  <path d="M295.142,214.31l5.66-86.31H62.769l19.016,290h114.172c-14.861-21.067-23.602-46.746-23.602-74.43   C172.355,274.43,226.849,217.779,295.142,214.31z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  <path d="M301.785,244.141c-54.826,0-99.43,44.604-99.43,99.429S246.959,443,301.785,443s99.43-44.604,99.43-99.43   S356.611,244.141,301.785,244.141z M355.961,376.533l-21.213,21.213l-32.963-32.963l-32.963,32.963l-21.213-21.213l32.963-32.963   l-32.963-32.963l21.213-21.213l32.963,32.963l32.963-32.963l21.213,21.213l-32.963,32.963L355.961,376.533z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                </g></g> </svg>
                <p>Usuń</p>
              </span>
              <span class="button-module-table" @click="$router.push('/product/add');" v-if="$parent.grantPermission(['ROLE_EDITOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])">
                <svg xmlns="http://www.w3.org/2000/svg" height="512px" viewBox="0 0 448 448" width="512px">
                  <g>
                    <path d="m408 184h-136c-4.417969 0-8-3.582031-8-8v-136c0-22.089844-17.910156-40-40-40s-40 17.910156-40 40v136c0 4.417969-3.582031 8-8 8h-136c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40h136c4.417969 0 8 3.582031 8 8v136c0 22.089844 17.910156 40 40 40s40-17.910156 40-40v-136c0-4.417969 3.582031-8 8-8h136c22.089844 0 40-17.910156 40-40s-17.910156-40-40-40zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#D3020C"/>
                  </g>
                </svg>
                <p>Nowy produkt</p>
              </span>
            </div>
          </div>
          <div v-if="reportMsg" class="report-info-box">
            {{reportMsg}}
            <span @click="reportMsg = ''">x</span>
          </div>
        <b-container fluid>
          <div class="table--wrapper">
            <b-table
              class="app-table products-table"
              show-empty
              stacked="md"
              striped
              :busy="isBusy"
              :items="products"
              :fields="fields"
              :paginated="false"
              :backend-sorting="true"
              @filtered="onFiltered"
              hover>

              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

              <template slot="HEAD_number" slot-scope="data">
                <div class="form-group">
                  <label :class="{'active' : sortField == 'number'}" @click="sortDir('number')" style="white-space: nowrap;">
                    {{ data.label }}
                    <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'number'"></div>
                  </label>
                  <input class="form-control form-control-lg" type="text" v-model="search.number" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_name" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'name'}" @click="sortDir('name')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'name'"></div>
                    </label>
                    <input class="form-control form-control-lg" type="text" v-model="search.name" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_producer" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'producer'}" @click="sortDir('producer')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'producer'"></div>
                    </label>
                    <input class="form-control form-control-lg" type="text" v-model="search.producer" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_images" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'images'}" @click="sortDir('images')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'images'"></div>
                    </label>
                    <input class="form-control form-control-lg" type="text" v-model="search.images" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_updatedAt" slot-scope="data">
                  <div class="form-group">
                    <label :class="{'active' : sortField == 'updatedAt'}" @click="sortDir('updatedAt')">
                      {{ data.label }}
                      <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'updatedAt'"></div>
                    </label>
                    <input class="form-control form-control-lg" type="text" v-model="search.updatedAt" @input="searching()"/>
                </div>
              </template>

              <template slot="HEAD_clear" slot-scope="data">
                <div class="form-group">
                  <div class="button-group">
                    <span class="button-normal button-normal--clear" @click="clearSearch()"><img src="../../assets/symbols/iks.svg" /></span>
                  </div>
                </div>
              </template>

              <template slot="check" slot-scope="row">
                <label class="checkbox checkbox--form" :class="{'disabled' : row.item.isBlocked}"><input type="checkbox" :value="row.item.id" @click="checkboxes(row.item)"/><span class="checkmark"></span></label>
              </template>
              
              <template slot="number" slot-scope="row">
                <span v-if="$parent.grantPermission(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']) && !row.item.isBlocked" class="select-link" @click="passDataFromDatabase(); $router.push(`/product/${row.item.id}/edit`)">{{ row.item.number }}</span>
                <div v-else>{{ row.item.number }}</div>
              </template>

              <template slot="name" slot-scope="row">
                {{row.item.name}}
              </template>

              <template slot="producer" slot-scope="row">
                {{row.item.producer}}
              </template>

              <template slot="images" slot-scope="row">
                {{row.item.images}}
              </template>

              <template slot="updatedAt" slot-scope="row">
                {{row.item.updatedAt}}
              </template>

            </b-table>
          </div>
        </b-container>
        <b-row>
            <b-col class="my-1">
              <b-pagination
                v-if="!products.length == 0"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0 float-right"
                @change="pageChange">
              </b-pagination>
            </b-col>
          </b-row>
      </div>
      <popup 
        v-if="warningPopup"
        title="Uwaga" 
        text="Czy na pewno chcesz usunąć produkty?" 
        cancelButton="Anuluj" 
        confirmButton="Usuń" 
        @confirmed="deleteConfirmation = true, deleteProduct()"
        @canceled="deleteConfirmation = false, warningPopup = false"/>

      <copyPopup 
        v-if="copy_popup" 
        @canceled="copy_popup = false; selectedItems = []; $parent.uncheckAllCheckboxes();"
        :selectedItems="selectedItems"/>

  </div>

</template>

<script>

import debounce from "lodash.debounce";
import popup from '@/components/blocks/popup'
import copyPopup from '@/components/blocks/productsBase/copyPopup.vue';
import { setTimeout } from 'timers';

export default {

  name: 'Products',
  components:{

    popup,
    copyPopup,

  },
  data () {

    return {

      title: 'Lista produktów',

      isBusy: false,
      fields: [

          {
            key: 'check', 
            label: '' 
          },
          {
            key: 'number', 
            label: 'Nr artykułu' 
          },
          {
            key: 'name', 
            label: 'Nazwa produktu' 
          },
          {
            key: 'producer', 
            label: 'Producent' 
          },
          {
            key: 'images', 
            label: 'Liczba zdjęć' 
          },
          {
            key: 'updatedAt', 
            label: 'Data aktualizacji' 
          },
          {
            key: 'clear', 
            label: '' 
          },

        ],

      products: [],
      selectedItems:[],
      warningPopup: false,
      copy_popup: false,
      deleteConfirmation: false,

      search:{
        number: '',
        name: '',
        producer: '',
        images: '',
        updatedAt: '',
      },

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      offset: 0,
      sort: false,
      sortDirection: 'ASC',
      sortField: 'number',

      reportMsg: '',

    }

  },
  methods:{

    generateReport(){

      this.isBusy = true;

      const token = localStorage.getItem('auth_token');

      this.$http.get('product/export/csv', {
      headers: {

      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'

      }})
      .then(response => {

        this.isBusy = false;
        this.reportMsg = response.data.message;

        setTimeout(()=>{
          this.reportMsg = '';
        }, 8000)

      })
      .catch(error =>{

        this.isBusy = false;
        console.error(error.response);

      })

    },

    clearSearch(){

        this.search.number =  '';
        this.search.name =  '';
        this.search.producer = '';
        this.search.images = '';
        this.search.updatedAt = '';
        this.sortField = 'number'; 
        this.sort = false;
        this.sortDirection = 'ASC',

        this.getProducts();

    },

    passDataFromDatabase(){

      const settings = {
        pagination:{
          totalRows: this.totalRows,
          currentPage: this.currentPage,
          perPage: this.perPage,
          offset: this.offset,
          sort: this.sort,
          sortDirection: this.sortDirection,
          sortField: this.sortField,
        },
        search: this.search
      }

      this.storeDataInStorage('dataFromDatabase', settings);

    },

    checkboxes(item){

      const id = item.id;
      const type = item.href ? 'image' : 'product';

      let obj = this.selectedItems.find(o => o.id === id);
      
      if(!obj){

        this.selectedItems.push({id: id, rowType: type, page: this.currentPage});
        return;

      }

      this.selectedItems = this.selectedItems.filter(o => o.id !== id);

    },

    selectCheckboxes() {

      let checkboxes = document.querySelectorAll("input[type='checkbox']");

      for (let i = 0; i < checkboxes.length; i++) {

        let product = this.selectedItems.find(product => product.id == checkboxes[i].value && product.page == this.currentPage);

        if(product){

          checkboxes[i].checked = true;

        }

      }

    },

    sortDir(field){

      if(field != this.sortField){

        this.sortField = field; 
        this.sortDirection = 'ASC';

        this.getProducts();

        return;

      }
      
      this.sortDirection == 'DESC' ? this.sortDirection = 'ASC' : this.sortDirection = 'DESC';
      this.sortField = field;
      this.getProducts();

    },

    setPerPage() {
      this.offset = 0;
      this.sortField = 'number';

      this.getProducts();

    },

    getProducts(){

      this.isBusy = true;
      const token = localStorage.getItem('auth_token');

      let request = {
        'limit' : this.perPage,
        'offset' : this.offset,
        'sort' : this.sortDirection,
        'sort_field' : this.sortField,
      }

      const entries = Object.entries(this.search);

      for (const [key, value] of entries) {
        
        if(value != ''){
          request[key] = value;
        }

      }
      
      this.$http.get('product/products', {
        params:request,
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.products = response.data.list;
          this.totalRows = response.data.total;
          this.isBusy = false;
          this.$parent.uncheckAllCheckboxes();

          setTimeout(() =>{
            this.selectCheckboxes();
          }, 100)

        })
        .catch(error =>{
          
          if(error.response.status === 401) {
            
            this.$router.push('/');

          }else{

            console.error(error.response);
            this.loading = false;

          }

        })

    },

    deleteProduct(){

      this.warningPopup = false;

      if(!this.deleteConfirmation){

        this.warningPopup = true;
        return;

      }

      this.isBusy = true;
      const token = localStorage.getItem('auth_token');

      if(this.selectedItems.length > 1){

        let selectedProducts = [];

        this.selectedItems.forEach(item =>{
          selectedProducts.push(item.id);
        })

        let toDelete = {
          products: selectedProducts
        }

        this.$http.delete(`product/products`, {data: toDelete,
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.getProducts();
          this.selectedItems = [];
          this.deleteConfirmation = false;

          this.$parent.uncheckAllCheckboxes();

        })
        .catch(error =>{

          console.error(error.response);
          this.loading = false;
          this.deleteConfirmation = false;

        })

      }

      if(this.selectedItems.length == 1){

        let toDelete = {
          confirm: 'true'
        }

        this.$http.delete(`products/${this.selectedItems[0].id}`, {data: toDelete,
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.getProducts();
          this.selectedItems = [];
          this.deleteConfirmation = false;

          this.$parent.uncheckAllCheckboxes();

        })
        .catch(error =>{

          console.error(error.response);
          this.getProducts();
          this.loading = false;
          this.deleteConfirmation = false;

        })

      }

    },

    copyProduct(){

      this.isBusy = true;
      const token = localStorage.getItem('auth_token');

      let toCopy = {
        products: this.itemsToCopy
      }

        this.$http.post(`products/copies/products`, toCopy, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            this.getProducts();
            this.copy_popup = false;
            this.itemsToCopy = [];

            this.$parent.uncheckAllCheckboxes();

          })
          .catch(error =>{

            console.error(error.response);
            this.loading = false;

          })

    },

    searching: debounce(function(){

      this.currentPage = 1;
      this.offset = 0;
      console.log(this.offset);
      this.getProducts();

    }, 1000),

    pageChange (page) {

      this.currentPage = page
      this.offset = ((this.currentPage - 1) * this.perPage)
      this.getProducts();
      
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

  },
  computed:{

    sortOptions() {

      return this.fields
        .filter(f => f.sordata-table)
        .map(f => {
          return { text: f.label, value: f.key }
         })
    }

  },
  mounted(){

    const settings = this.getDataFromStorage('dataFromDatabase');

    if(settings){

      this.currentPage = settings.pagination.currentPage;
      this.perPage = settings.pagination.perPage;
      this.offset = settings.pagination.offset;
      this.sort = settings.pagination.sort;
      this.sortDirection = settings.pagination.sortDirection;
      this.sortField = settings.pagination.sortField;

      this.search = settings.search;

      this.clearStorage('dataFromDatabase');

    }

    this.getProducts();

  },

};
</script>

<style lang="scss">
.copy-product-background{
    position:fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background: rgba(172, 172, 172, 0.411);
}

.copy-product{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:30%;
    padding:20px;
    z-index: 1000;
    background:#fff;
    border:1px solid red;

    &__title{
      width:100%;
      margin-bottom: 20px;
    }

    &__body{
      width:100%;
    }

    &__footer{
        display:flex;
        width:100%;
        justify-content: space-around;
        padding: 10px 0px;
    }
}

.products-table {
  table-layout: fixed; 
  border-spacing: 10rem 0rem !important;

  thead th {
      padding: 2rem 1rem !important;

      &:nth-child(1){
          width: 5rem !important;
      }
  }
}

.report-info-box{
  display:flex;
  justify-content: space-between;
  padding:5px;
  border-radius: 5px;
  width:100%;
  background: rgb(123, 160, 38);
  color: #fff;
  font-weight: 600;
  font-size: 12px;

  span{
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>